import "core-js/modules/es.array.for-each";
import "core-js/modules/es.function.name";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, commonData } from "@/mixins/index";
import unseal from "./unseal.vue"; // import studentScore from "./studentScore.vue";

export default {
  mixins: [loadMoreList, commonData],
  components: {
    unseal: unseal
  },
  data: function data() {
    return {
      dialogFormVisible: false,
      teamId: '',
      tableData: [],
      total: 0
    };
  },
  computed: {},
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (data) {
                  _this.teamId = data;

                  _this.getTeamListFn();
                }

                _this.dialogFormVisible = true;

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getTeamListFn: function getTeamListFn() {
      var _this2 = this;

      this.$api.regTeamList(_objectSpread(_objectSpread({}, this.paramsData), {}, {
        id: this.teamId
      })).then(function (res) {
        if (res.code == 200) {
          _this2.tableData = res.data.data;

          _this2.tableData.forEach(function (item) {
            item.name = item.team.name;
            item.logo = item.team.logo;
            item.introduction = item.team.introduction;
          });

          _this2.total = res.data.total;
        }
      });
    },
    passClick: function passClick(id, status) {
      var _this3 = this;

      this.$api.auditTeam({
        id: id,
        status: status
      }).then(function (res) {
        if (res.code == 200) {
          _this3.$message.success('操作成功');

          _this3.getTeamListFn(_this3.paramsData.page);
        } else {
          _this3.$message.error(res.msg);
        }
      });
    }
  }
};